{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Odabir boje",
  "colorSwatch": "uzorak boje",
  "transparent": "transparentno",
  "twoDimensionalSlider": "2D klizač"
}
